import React from 'react';
import { ScoreProvider } from './components/ScoreContext';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { HeroV2 } from './components/v2/HeroV2';
import { BusinessPayoffV2 } from './components/v2/BusinessPayoffV2';
import { Gap } from './components/v2/Gap';
import { QuickCheck } from './components/v2/QuickCheck';
import { Solution } from './components/v2/Solution';
import { PrototypeProof } from './components/v2/PrototypeProof';
import { FitInvestment } from './components/v2/FitInvestment';
import { AuthorLeverage } from './components/v2/AuthorLeverage';
import { SalesEnablement } from './components/v2/SalesEnablement';
import { DoneForYou } from './components/v2/DoneForYou';
import { ScoreAuditBuild } from './components/v2/ScoreAuditBuild';
import { FaqFinalCta } from './components/v2/FaqFinalCta';
export function AppV2() {
  return <ScoreProvider data-id="element-16" data-mp="7x51n1s4osv6">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass-ink selection:text-white" data-id="element-17" data-mp="7vk7hd9q7bxu">
        <a href="#main-content" className="skip-link" data-id="element-18" data-mp="ctlolsnld16o">
          Skip to main content
        </a>
        <Nav data-id="element-19" data-mp="hv2rtutjszqf" />
        <main id="main-content" data-id="element-20" data-mp="hsggdk3je02x">
          <HeroV2 data-id="element-21" data-mp="mu5ux9pywvvr" />
          <BusinessPayoffV2 data-id="element-22" data-mp="mskzlhvtx8wu" />
          <Gap data-id="element-23" data-mp="msuqr8sm1m44" />
          <QuickCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check" confirmationText="Saved. This is part of your Reader-to-Revenue Score." data-id="element-24" data-mp="mr9wlka7k56s" />
          <Solution data-id="element-25" data-mp="3qb4ihtsmb2ez" />
          <PrototypeProof data-id="element-26" data-mp="3qamcw6k2fbue" />
          <FitInvestment data-id="element-27" data-mp="3v9fuob6dxp0d" />
          <AuthorLeverage data-id="element-28" data-mp="3v9600aaeatoc" />
          <SalesEnablement data-id="element-29" data-mp="3v7uykh4f9y0e" />
          <DoneForYou data-id="element-30" data-mp="3v7l70p3qbisl" />
          <ScoreAuditBuild data-id="element-31" data-mp="3ui7gu7zivut" />
          <FaqFinalCta data-id="element-32" data-mp="3vthvcvxr1uw" />
        </main>
        <Footer data-id="element-33" data-mp="3wuwtsg2o8hw" />
        <StickyWidget data-id="element-34" data-mp="32ks17sbhftbq" />
        <Diagnostic data-id="element-35" data-mp="32ljyd7kq9z44" />
      </div>
    </ScoreProvider>;
}